const appEditBaseConfigs = {
  id: null,
  app_name: '',
  config: [],
  is_sort: '1',
  is_qrcode_preview: '1',
  is_video_unique: '1',
  is_set_alias: '1',
  subject_ids: [],
  catalog: {
    is_fixed_seq: '1',
    catalog: []
  },
  relation_data: {
    catalog: {},
    base_info_extend_field_config: {}
  }
}

const resourceLibs = {
  1: '素材库',
  2: '题库',
  3: '视频库',
  4: '游戏',
  5: '未来号视频'
}

const catalogOrders = {
  1: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
    '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七', '二十八', '二十九', '三十', '三十一', '三十二', '三十三', '三十四', '三十五',
    '三十六', '三十七', '三十八', '三十九', '四十', '四十一', '四十二', '四十三', '四十四', '四十五', '四十六', '四十七', '四十八', '四十九', '五十',
    '五十一', '五十二', '五十三', '五十四', '五十五', '五十六', '五十七', '五十八', '五十九', '六十',
  ],
  2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60],
  3: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳', '㉑', '㉒', '㉓', '㉔',
  '㉕', '㉖', '㉗', '㉘', '㉙', '㉚', '㉛', '㉜', '㉝', '㉞', '㉟', '㊱', '㊲', '㊳', '㊴', '㊵', '㊶', '㊷', '㊸', '㊹', '㊺', '㊻', '㊼', '㊽', '㊾',
  '㊿']
}

// 应用编辑自定义字段类型
const appConfigTypes = {
  '1': '单行文本',
  '2': '多行文本',
  '3': '单选菜单',
  '4': '时间选择'
}

const state = {
  magicLineNum: 4, // 我的魔方应用列表一行显示个数
  menuLevel: 1, // 目录层级
  realname: '', // 用户姓名
  avatar: '', // 用户头像
  subject_id: '', // 学科id
  department_id: '', // 学部id
  menu: [], // 导航列表
  baseConfigs: {}, // 基础配置参数
  userAppList: [], // 用户可用app列表
  appListData: {}, // 应用内数据列表
  appListCount: null, // 应用内数据列表总数
  appBaseData: {}, // 应用基本信息
  appRelationCatalogInfos: {}, // app关联目录信息
  catalogTypes: [],
  appEditBaseConfigs: appEditBaseConfigs, // 应用配置基本字段
  allAppList: [], // 所有应用列表
  appConfig: {}, // 应用配置信息
  appConfigTypes: appConfigTypes, // 应用编辑自定义字段类型
  appEditConfigs: {}, // 应用编辑页数据
  resourceLists: [], // 资源库列表
  componentsLists: [], // 组件列表
  catalogOrders: catalogOrders,
  resourceLibs: resourceLibs,
  // 拖拽定位用
  positionList: [],
  showIcon: false,
  // 拖拽信息存储，跨组件
  navDrag: false,
  dragIndexList: [],
  dragDeepth: undefined,
  dragParentCatalogId: undefined,
  dragFailTip: '',
  dragIsFixed: false,
  readArticlePreviewData: {} // 一起读书预览数据
}

export default state



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/vuex/magicCube/state.js